import PropTypes from 'prop-types';

import * as Styled from './CalloutVideo.style';

function CalloutVideo({ videoId, clickstreamProps }) {
  return (
    <Styled.Video
      clickstreamProps={clickstreamProps}
      data-testid={`callout-video-${videoId}`}
      videoId={videoId}
      width="100%"
    />
  );
}

CalloutVideo.propTypes = {
  clickstreamProps: PropTypes.object.isRequired,
  videoId: PropTypes.string.isRequired
};

export default CalloutVideo;
